import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
    TabComponentTab,
    TabbedComponent,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useApplication} from '../hooks/useApplication.ts';
import {useApplicationsSelection} from '../hooks/useApplicationsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {useApplications} from "../hooks/useApplications.ts";


export const EditPage = () => {


    const {id: applicationId} = useParams();

    if (typeof applicationId === 'undefined') {
        throw new Error('applicationId is required parameter');
    }

    const {fetchRecords} = useApplications();

    const {
        record: application,
        fetchRecord,
        updateRecord,
    } = useApplication(applicationId);

    const {handleClearSelection} = useApplicationsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchRecord();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicationId]);


    const tabs = [] as TabComponentTab[]


    if (!application) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={application.name ? application.name : application.id}
            pageNavigation={<EditPageNavigation component={application}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile
                            record={application}
                        />
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <TabbedComponent tabs={tabs}/>
                    </Grid.Col>
                </Grid>

                :
                <SimplePageContentWrapper>
                    <RecordForm
                        record={application}
                        handleSubmit={updateRecord}
                    />
                </SimplePageContentWrapper>
            }


        </FormPageLayout>
    );
};
